import { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';
import { Cookies } from 'react-cookie';
import { clearInsuranceProfile } from '../../../../../actions/insuranceProfile';
import { clearInsuranceDetails } from '../../../../../ducks/insurance/details';
import { resetLoginData } from '../../../../../actions/login';
import { clearUserInfo } from '../../../../../core/session';

export default (toggleDrawer: any) => {
  const dispatch = useDispatch();

  return useCallback(() => {
    const cookies = new Cookies();
    clearUserInfo(cookies);
    batch(() => {
      dispatch(clearInsuranceProfile());
      dispatch(clearInsuranceDetails());
      dispatch(resetLoginData());
    });
    toggleDrawer();
  }, [dispatch, toggleDrawer]);
};
